import { Box, InputGroup } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

import { Select } from '~/packages/common-frontend/components/Select';
import { useFundingRequestTemplateContextV1 } from '~/packages/funding-requests/hooks/useFundingRequestTemplateContextV1';
import { InvoiceMechanicsSelect } from '~/packages/funding-requests/ui/submit/CreateRequest/InvoiceMechanicsSelect';

type PricingOptionSelectProps = {
  isDisabled?: boolean;
};

export const PricingOptionSelect = ({
  isDisabled = false,
}: PricingOptionSelectProps) => {
  const { context } = useFundingRequestTemplateContextV1();

  const {
    data: { pricingOptions, expectedSubmission },
    setValue,
  } = context;

  const [pricingOption, setPricingOption] = useState<string | undefined>(
    expectedSubmission.draw.global.pricingOptionKey,
  );

  useEffect(() => {
    setPricingOption(expectedSubmission.draw.global.pricingOptionKey);
  }, [expectedSubmission.draw.global.pricingOptionKey]);

  const hasMultiplePricingOptions = pricingOptions.length > 1;

  return (
    <Box w="100%">
      <InputGroup w="100%" bgColor="white">
        <Select
          placeholderLabel="Select pricing option"
          options={pricingOptions.map(
            ({ key, name }: { key: string; name: string }) => ({
              label: name,
              value: key,
            }),
          )}
          // @jendevelops this is for a global draw pricing option, if need individual need to take the pricingOptionKey from individual drawRequest
          value={pricingOption}
          onChange={(newValue) => {
            setPricingOption(newValue);
            if (newValue) {
              setValue({
                type: 'setPricingOptions',
                options: {
                  pricingOptionKey: newValue,
                  // @jendevelops drawRequestKey purposefully left off because we're only dealing with global pricing option for now
                  drawRequestKey: undefined,
                  invoiceMechanicsKey: undefined,
                },
              });
            }
          }}
          isDisabled={
            context.allowedActions === 'readOnly' ||
            !hasMultiplePricingOptions ||
            isDisabled
          }
        />
      </InputGroup>
      {pricingOption && (
        <InvoiceMechanicsSelect
          selectedPricingOption={pricingOption}
          isDisabled={isDisabled}
        />
      )}
    </Box>
  );
};
